if (!customElements.get('permalink-share')) {
  theme.permalinkShare = class extends HTMLElement {
    constructor() {
      super();
      this.SHARE_BTN_SELECTOR = '[data-permalink-share-button]';
      this.SHARE_INPUT_SELECTOR = '[data-permalink-share-input]';
      this.SHARE_COPY_SELECTOR = '[data-permalink-share-copy]';
      this.SHARE_ITEMS_INPUT_SELECTOR = '[data-permalink-share-items-input]';
      this.SHARE_ITEMS_COPY_SELECTOR = '[data-permalink-share-items-copy]';
      this.EVENT_LINK_UPDATED = 'permalinkShare:updated';
      this.EVENT_ITEMS_UPDATED = 'permalinkShare:updatedItems';
      this.KEEP_SHARE_PARENT_SELECTOR = '.incubate-keep-and-share-your-cart-widget';
      this.KEEP_SHARE_SELECTOR = '.incubate-keep-and-share-your-cart-copy';
      this.HIDE_CLASS = 'hide';
      this._onClickSaveButton = this._onClickSaveButton.bind(this);
      this._onCreateCartPermalinkUpdated = this._onCreateCartPermalinkUpdated.bind(this);
      this._onCreateCartPermalinkItemsUpdated = this._onCreateCartPermalinkItemsUpdated.bind(this);
      this._copyToClipboard = this._copyToClipboard.bind(this);
      this.addEventListener(this.EVENT_LINK_UPDATED, this._onCreateCartPermalinkUpdated);
      this.addEventListener(this.EVENT_ITEMS_UPDATED, this._onCreateCartPermalinkItemsUpdated);
      this.addEventListener('click', (e) => {
        if (e?.target) {
          if (e?.target?.matches?.(this.SHARE_BTN_SELECTOR) || this.saveButton?.contains?.(e?.target)) {
            this._onClickSaveButton(e);
          } else if (e?.target?.matches?.(this.SHARE_COPY_SELECTOR) || this.copyButton?.contains?.(e?.target)) {
            this._copyToClipboard(this.shareInput);
          } else if (e?.target?.matches?.(this.SHARE_ITEMS_COPY_SELECTOR) || this.itemsCopyButton?.contains?.(e?.target)) {
            this._copyToClipboard(this.itemsInput);
          }
        }
      });
    }
    connectedCallback() {
      this.setExcludedProperties();
      this.saveButton = this.querySelector(this.SHARE_BTN_SELECTOR);
      this.copyButton = this.querySelector(this.SHARE_COPY_SELECTOR);
      this.shareInput = this.querySelector(this.SHARE_INPUT_SELECTOR);
      this.itemsInput = this.querySelector(this.SHARE_ITEMS_INPUT_SELECTOR);
      this.itemsCopyButton = this.querySelector(this.SHARE_ITEMS_COPY_SELECTOR);
      this.keepShareObserver = this._initKeepShareObserver();
      this.keepShareCopyErrorObserver = this._initKeepShareObserverCopyError();
    }
    disconnectedCallback() {
      this.keepShareObserver?.disconnect();
      this.keepShareCopyErrorObserver?.disconnect();
    }
    setExcludedProperties() {
      const data = this.dataset.excludeLineProperties || '[]'
      try {
        this.excludedProperties = new Set(JSON.parse(data));
      } catch (error) {
        this.excludedProperties = new Set();
      }
    }
    replaceHTMLEntities(str) {
      const htmlEntities = {
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#039;': "'",
        '&#39;': "'",
        '&ndash;': '-',
      };
    
      return str.replace(/&[\w#]+;/g, entity => {
        return htmlEntities[entity] || entity;
      });
    }
    async _onClickSaveButton(e) {
      e.preventDefault();
      const cart = await this._fetchCart();
      const items = this._formatCartItems(cart?.items || []);
      const keepShareBtn = document.querySelector(this.KEEP_SHARE_SELECTOR);

      if (keepShareBtn) {
        keepShareBtn.click();
      } else {
        console.log("Error saving cart.");
      }

      if (items) {
        this.dispatchEvent(new CustomEvent(this.EVENT_ITEMS_UPDATED, {
          detail: {
            data: items
          }
        }));
      }
    }
    // Generate human readable variant title and quantity
    _formatCartItems(items) {
      let cartItems = '';

      if (items?.length) {
        cartItems = items.reduce((acc, item) => {
          const {
            options_with_values,
            product_title,
            properties,
            quantity,
          } = item || {};
          if (product_title && quantity) {
            const decodedTitle = decodeURIComponent(product_title);
            const formattedTitle = this.replaceHTMLEntities(decodedTitle);
            let displayText = `(Qty: ${quantity}) ${formattedTitle}`;
            let lineItemPropText = '';

            lineItemPropText = options_with_values?.reduce((accTxt, option) => {
              if (option && option.name && option.value !== 'Default Title') {
                if (accTxt) {
                  accTxt += '\r\n';
                }
                accTxt += `\t- ${option.name}: ${option.value}`;
              }

              return accTxt
              
            }, lineItemPropText);


            lineItemPropText = (Object.entries(properties || {}))?.reduce((accTxt, [key, value]) => {
              if (key && value && !this.excludedProperties.has(key)) {
                const sanitizedValue = value.replace(/[\r\n]+/g, ' ');
                if (accTxt) {
                  accTxt += '\r\n';
                }
                accTxt += `\t- ${key}: ${sanitizedValue}`;
              }

              return accTxt;

            }, lineItemPropText);

            if (acc) {
              acc += `\r\n\r\n`;
            }

            if (lineItemPropText) {
              displayText += `\r\n${lineItemPropText}`;
            }

            acc += displayText;
          }
          return acc;
        }, cartItems);
      }

      return cartItems;
    }
    // Generate Shopify cart permalink
    _formatCartLinkParams(items) {
      let permaLink = '';
  
      if (items?.length) {
        permaLink = items.reduce((acc, item) => {
          const {
            variant_id,
            quantity
          } = item || {};
          if (variant_id && quantity) {
            if (acc) {
              acc += ',';
            }
            acc += `${variant_id}:${quantity}`;
          }
          return acc;
        }, permaLink);

        if (permaLink) {
          // Determine if the permalink should send to cart or checkout
          const isCartDestination = (this.dataset?.permalinkDestination || 'cart') === 'cart' ? true : false;
          const destination = isCartDestination ? '?storefront=true' : '';
          permaLink = `${window.theme.routes.secureShopUrl}/cart/${permaLink}${destination}`;
        }
      }
  
      return permaLink;
    }
    async _copyToClipboard(target) {
      if (target) {
        const text = target.value;
        target.select();
        
        if ('clipboard' in navigator) {
          try {
            await navigator.clipboard.writeText(text);
          } catch (err) {
            console.error(err.name, err.message);
          }
        } else {
            try {
              document.execCommand('copy');
            } catch (err) {
              console.error(err.name, err.message);
            }
        }
      }
    }
    _onCreateCartPermalinkUpdated(e) {
      const {
        data
      } = e.detail || {};
      this._updateShareElems(data, this.shareInput, this.copyButton);
    }
    _onCreateCartPermalinkItemsUpdated(e) {
      const {
        data
      } = e.detail || {};
      this._updateShareElems(data, this.itemsInput, this.itemsCopyButton);
    }
    _updateShareElems(data, target, targetCopy) {
      if (target) {
        target.value = data || '';
        if (data) {
          targetCopy?.removeAttribute('disabled');
        } else {
          targetCopy?.setAttribute('disabled', '');
        }
      }
    }
    async _fetchCart() {
      let cart = {};
      try {
        const response = await fetch(Shopify.routes.root + "cart.js");
        if (response?.ok) {
          cart = await response.json();
        }
      } catch (error) {
        console.error("****** | fetchCart | error:", error);
      }
  
      return cart;
    }
    _initKeepShareObserver() {
      const element = document.querySelector(this.KEEP_SHARE_SELECTOR);

      if (!element) {
        const observer = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              for (const node of mutation.addedNodes) {

                if (node?.matches?.(this.KEEP_SHARE_PARENT_SELECTOR)) {
                  const copyBtn = node?.querySelector?.(this.KEEP_SHARE_SELECTOR);
                  
                  if (copyBtn) {
                    this?.classList?.remove(this.HIDE_CLASS);
                    observer.disconnect();
                  }
                  break;
                }
              }
            }
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return observer;
      } else {
        this?.classList?.remove(this.HIDE_CLASS);
      }
    }
    _manipulateKeepCopyErrorElems(node) {
      if (node) {
        const HIDE_CLASS = 'hide';
        node.classList.add(HIDE_CLASS);
        const warningElem = node?.querySelector?.(".swal2-icon-warning");
        const warningMessage = warningElem?.querySelector('.swal2-input-label');
        const warningInput = warningElem?.querySelector('#swal2-input');
        
        if (warningMessage && warningInput) {
          if (warningMessage?.innerHTML?.includes('could not be copied')) {
            const warningIcon = warningElem?.querySelector(".swal2-warning");
            const headerElem = warningElem?.querySelector("#swal2-title");
            warningMessage.innerHTML = "Please copy the link below and share it.";

            if (warningIcon) {
              warningIcon.remove();
            }

            if (headerElem) {
              headerElem.remove();
            }
            if (warningInput) {
              warningInput.select();
              warningInput.focus();
            }
          }

          if (warningInput) {
            node.classList.remove(HIDE_CLASS);
            warningInput.select();
            warningInput.focus();

          }
        }
        node.classList.remove(HIDE_CLASS);
      }
    }
    _initKeepShareObserverCopyError() {
      const KEEP_CONTAINER_SELECTOR = '.swal2-container';
      const element = document.querySelector(KEEP_CONTAINER_SELECTOR);
      const context = this;

      if (!element) {
        const observer = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              for (const node of mutation.addedNodes) {

                if (node?.matches?.(KEEP_CONTAINER_SELECTOR)) {
                  context._manipulateKeepCopyErrorElems(node);
                  break;
                }
              }
            }
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });

        return observer;
      } else {
        this._manipulateKeepCopyErrorElems(element);
      }
    }
  }
  window.customElements.define("permalink-share", theme.permalinkShare);
}